export default __webpack_public_path__ + "static/misc1-7a5bc78bb9a040ca8b291123508a286b.jpg";